export const salt = '$2a$05$IFgpOgFXEHMZCQt/Wxgg3u';
